'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z' });

var Drafts = function Drafts(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Drafts = (0, _pure2.default)(Drafts);
Drafts.muiName = 'SvgIcon';

exports.default = Drafts;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Drafts.js
// module id = 2338
// module chunks = 0